module.exports = __webpack_public_path__ + "static/media/bars.f4e64106.svg";